import { NO } from './roadwayVariables'

export const BIKE_FACILITY_TYPE = 'bike_facility_type'
export const BIKE_FACILITY_TYPE_VALUES = [
  'No dedicated bikeway',
  'Bike lane (no buffer)',
  'One-way in-roadway',
  'One-way raised',
  'Two-way in-roadway',
  'Two-way raised'
]

export const STREET_BUFFER_WIDTH = 'street_buffer_width'
export const STREET_BUFFER_WIDTH_VALUES = [
  '> 6ft or continuous barrier',
  '3 to 6ft',
  '< 3ft'
]

export const BUFFER_BIKE_TRAVEL_LANE = 'buffer_bike_travel_lane'
export const BUFFER_BIKE_TRAVEL_LANE_VALUES = [
  'On-street parking',
  'Delineator posts or bollards',
  'Raised median or barrier',
  'Painted buffer'
]
export const USABLE_BIKEWAY_WIDTH = 'usable_bikeway_width'
export const USABLE_BIKEWAY_WIDTH_VALUES = [
  '>= 14 ft',
  '11 to <14 ft',
  '10 to <11 ft',
  '8 to <10 ft',
  '6.5 to <8 ft',
  '5 to <6.5 ft',
  '4 to <5 ft',
  '< 4ft'
]

export const SPECIAL_CONSIDERATIONS = 'special_considerations'
export const SPECIAL_CONSIDERATIONS_VALUES = [
  'High volume of street dining',
  'Vehicles parked in bikeway'
]

export const CURBSIDE_MANAGEMENT = 'curbside_management'
export const CURBSIDE_MANAGEMENT_VALUES = [
  'Vehicle loading planned through design',
  'Vehicle loading not accommodated through design'
]
export const BUFFER_BIKE_SIDEWALK = 'buffer_bike_sidewalk'
export const BUFFER_BIKE_SIDEWALK_VALUES = [
  'Half-height bike lanes',
  'Object separation',
  'Visual separation'
]
export const SIDEWALK_WIDTH = 'sidewalk_width'
export const SIDEWALK_WIDTH_VALUES = ['>= 6ft', '5 to 6ft', '< 5ft']

export const SHARED_LANE_PAVEMENT_MARKINGS_PRESENT =
  'shared_lane_pavement_markings_present'
export const SHARED_LANE_PAVEMENT_MARKINGS_PRESENT_VALUES = [
  'Yes; < 250 ft apart',
  'Yes; >= 250 ft apart',
  NO
]
export const LATERAL_DISTANCE_BETWEEN_MARKINGS_AND_EDGE_OF_SIDEWALK_OR_PARKED_CARS =
  'lateral_distance_between_markings_and_edge_of_sidewalk_or_parked_cars'
export const LATERAL_DISTANCE_BETWEEN_MARKINGS_AND_EDGE_OF_SIDEWALK_OR_PARKED_CARS_VALUES =
  ['>= 4 ft', '< 4 ft', 'None present']
export const MID_BLOCK_CONFLICTS = 'mid_block_conflicts'
export const MID_BLOCK_CONFLICTS_VALUES = [
  '<= 2 conflict points per block AND low volume OR raised crossings',
  '3-4 conflict points per block AND low volume OR raised crossings',
  '>= 5 conflict points per block OR high volume'
]
